import React, { useState, useEffect } from 'react';

const ClockPicker = ({ onSelect }) => {
    const [hours, setHours] = useState(12);
    const [minutes, setMinutes] = useState(0);

    const handleHourChange = (e) => {
        setHours(parseInt(e.target.value, 10));
    };

    const handleMinuteChange = (e) => {
        setMinutes(parseInt(e.target.value, 10));
    };

    useEffect(() => {
        // Gọi hàm callback onSelect ngay khi có sự thay đổi về giờ và phút
        onSelect(`${hours}:${minutes < 10 ? '0' : ''}${minutes}`);
    }, [hours, minutes, onSelect]);

    return (
        <div>
            <div className="flex">
                <div>
                    <label>Hours:</label>
                    <input type="number" value={hours} onChange={handleHourChange} min={1} max={23} />
                </div>
                <div className="px-2">
                    <label>Minutes:</label>
                    <input type="number" value={minutes} onChange={handleMinuteChange} min={0} max={59} />
                </div>

            </div>
        </div>
    );
};

export default ClockPicker;
